export const DEFAULT_DISMISSIBLE_MESSAGE_DELAY = 10;
